<template>
  <img
    ref="baseImg"
    :src="imgSrc"
    :alt="alt"
    class="is-cover"
    rel="preload"
    @error="$event.target.src = imgErrorSrc"
  />
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    errorSrc: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultImg: require('@assets/images/activity_default.png'),
    }
  },
  computed: {
    imgSrc () {
      return this.src || this.errorSrc || this.defaultImg
    },
    imgErrorSrc () {
      return this.errorSrc || this.imgSrc
    }
  },
  mounted() {
    this.$refs.baseImg.src = this.imgErrorSrc;

    let img = new Image();

    img.src = this.imgSrc;


    img.onload = (e) => {
      this.$refs.baseImg.src = img.src;
    };

    img.onerror = (e) => {
      this.$refs.baseImg.src = this.imgSrc;
    };
  }
}
</script>
